class UHFSearch {
  constructor () {
    setTimeout(() => {
      window.msCommonShell.load({
        as: {
          callback: function(query) {
            const data = new FormData()

            data.append('action', 'search_results')
            data.append('s', query.text)

            fetch(unlocked.ajax_url, {
              method: 'POST',
              credentials: 'same-origin',
              body: data
            })
              .then((response) => {
                response.json()
                  .then(items => {
                    const results = items.map(result => {
                      return {
                        type: 'product',
                        value: result
                      }
                    })
                    query.response(results)
                  })
              })
              .catch((error) => { console.log('error', error) })
          }
        }
      })
    }, 1000)
  }
}

export default UHFSearch
